/* --------------------------------------
  TOPページ
  コーディネートから探すセクション スライダー
-------------------------------------- */
const swiper_featured_blog_bg = new Swiper('.featured_blog__swiper_bg', {
  loop: true,
  effect: "fade",
  fadeEffect: {
    crossFade: true
  },
  slidesPerView: 1,
  speed: 700
});
const swiper_featured_blog = new Swiper('.featured_blog__swiper', {
  loop: true,
  effect: 'slide',
  fadeEffect: {
    crossFade: true
  },
  slidesPerView: 1,
  speed: 500,
  slideToClickedSlide: true,
  thumbs: {
    swiper: swiper_featured_blog_bg,
  },
  navigation: {
    nextEl: '.featured_blog__swiper-button-next',
    prevEl: '.featured_blog__swiper-button-prev',
  },
  pagination: {
    el: '.featured_blog__swiper__pagination',
    clickable: true,
  },
  on: {
    init: function () {
      let slideNum = [];
      let slideLength = document.querySelectorAll('.featured_blog__swiper .swiper-wrapper .swiper-slide').length;

      if (this.loopedSlides) {
        for (let i = 0; i < slideLength; i++) {
          slideNum.push(document.querySelector('.featured_blog__swiper .swiper-wrapper').getElementsByClassName('swiper-slide')[i].dataset.swiperSlideIndex);
        }
        maxSlideNum = Math.max(...slideNum) + 1;
      } else {
        maxSlideNum = slideLength;
      }
      document.querySelector('.js-Maxnum').innerHTML = maxSlideNum;
      document.querySelector('.js-currentNum').innerHTML = 1;
    },
    transitionStart: function () {
      let thisSlideIndex = this.realIndex + 1; // スライド番号は0から始まるので1を足す
      document.querySelector('.js-currentNum').innerHTML = thisSlideIndex;
    },
  }
});

/* --------------------------------------
  スマホドロワーメニュー、ヘッダー検索
  メニューアコーディオン
-------------------------------------- */
const ac = document.querySelectorAll(".js-drawerMenuAccordion");
const acSub = document.querySelectorAll(".js-drawerSubMenuAccordion");

// 親カテゴリークリック
function acToggle() {
  const content = this.nextElementSibling;
  this.classList.toggle('is-open');
  content.classList.toggle("is-open");
  event.preventDefault();
}

// サブカテゴリークリック
function acSubToggle(event) {
  const content = this.nextElementSibling;
  this.classList.toggle('is-open');
  content.classList.toggle('is-open');

  // 親要素とそのインデックスを取得
  const parent = this.parentElement;
  const children = parent.parentElement.children;
  const index = Array.prototype.indexOf.call(children, parent);

  // ターゲットとなる親要素を決定
  const targetIndex = index % 2 === 0 ? index + 1 : index - 1;
  if (children[targetIndex]) {  // ターゲットが存在するかのチェック
    const targetParent = children[targetIndex];
    // 'is-open'クラスを持つ要素を取得し、クラスを削除
    const targetElements = targetParent.querySelectorAll('.is-open');
    targetElements.forEach(element => element.classList.remove('is-open'));
  }

  event.preventDefault();
}

for (let i = 0; i < ac.length; i++) {
  ac[i].addEventListener("click", acToggle);
}

for (let i = 0; i < acSub.length; i++) {
  acSub[i].addEventListener("click", acSubToggle);
}

/* --------------------------------------
  スマホ商品詳細
  画像拡大時にスライドをスムーズに動かす
-------------------------------------- */
var productZoomButton = document.querySelector('.product-gallery__zoom-button');
if (productZoomButton) {
  productZoomButton.addEventListener('click', function() {
    setTimeout(function() {
      document.querySelector('.pswp__container').classList.add('transition');
    }, 500);
  });
}

/* --------------------------------------
  通過シンボルのサイズの変更
-------------------------------------- */
const downsizeCurrencySymbols = () => {
  const priceItems = document.querySelectorAll('.price-list');
  priceItems.forEach((priceItem) => {
    var originalText = priceItem.innerHTML;
    if (priceItem.classList.contains('downsized')) {
      // バリアントクリック時にtheme.jsで¥がついてしまうので一旦消す対応
      originalText = originalText.replace(/<span class="mini-symbol">¥<\/span>/g, '¥');
      originalText = originalText.replace(/¥¥/g, '¥');
    }
    var newText = originalText.replace(/¥/g, '<span class="mini-symbol">¥</span>');
    priceItem.innerHTML = newText;

    priceItem.classList.add('downsized');
  });
}

window.addEventListener('DOMContentLoaded', (event) => {
  setTimeout(() => {
    const observer = new MutationObserver(function() {
      observer.disconnect();
      downsizeCurrencySymbols();
      observer.observe(elem, config);
    });
    const config = {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true
    };
    let elem;
    if (document.body.classList.contains('template-product')) {
      elem = document.querySelector('.product-info__block-item[data-block-type="price"]');
    } else {
      elem = document.querySelector('.product-card');
    }
    if (elem) {
      observer.observe(elem, config);
    }
    downsizeCurrencySymbols();
  }, 500);//recently viewed productsなど読み込みの遅いものがあるので0.5秒たってから処理する
});
